import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getCurrencyMappings,
  getTransactionById,
  getTransactions,
  type TransactionListParams,
} from "@/apis/transaction/transaction-apis";
import { queryKeys } from "./keys";

export function useTransactions(
  params: TransactionListParams,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.transactions.list(params),
    queryFn: () => getTransactions(params),
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}

export function useTransaction(id: string | null) {
  return useQuery({
    queryKey: queryKeys.transactions.detail(id ?? ""),
    // Query is disabled when id is null, so queryFn won't run with fallback value
    queryFn: () => getTransactionById(id ?? ""),
    enabled: Boolean(id),
  });
}

export function useCurrencyMappings() {
  return useQuery({
    queryKey: queryKeys.enums.currencyMappings,
    queryFn: getCurrencyMappings,
    staleTime: Infinity,
  });
}
